import { render } from "./EmptyPage.vue?vue&type=template&id=3d03791c&scoped=true"
import script from "./EmptyPage.vue?vue&type=script&lang=js"
export * from "./EmptyPage.vue?vue&type=script&lang=js"

import "./EmptyPage.vue?vue&type=style&index=0&id=3d03791c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d03791c"]])

export default __exports__